<template>
  <el-dialog
    title="添加产品"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
    :close-on-click-modal="false"
  >
    <!-- <div class="el-form-item el-form--label-left" label="搜索对象" v-if="multiple">
      <label class="el-form-item__label" style="width: 80px;">搜索对象</label>
      <div class="el-form-item__content">
        <el-radio-group v-model="search_table">
          <el-radio label="item">零件</el-radio>
          <el-radio label="device">设备</el-radio>
        </el-radio-group>
      </div>
    </div>-->
    <el-tabs v-model="tabActive">
      <el-tab-pane label="从产品库添加" name="tab1">
        <el-input
          placeholder="输入件号或名称搜索"
          v-model="keyword"
          class="input-with-select"
          prefix-icon="el-icon-search"
          clearable
        ></el-input>
        <el-table
          v-if="items.length > 0"
          ref="multipleTable"
          @selection-change="handleItemSelectionChange"
          :data="items"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="名称/件号/机型">
            <template slot-scope="scope">
              <div>
                {{ scope.row.name }}
              </div>
              <div>
                {{ scope.row.part_number }}
              </div>
              <div>
                {{ scope.row.machine_type }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="price" label="定价" width="100">
            <template slot-scope="scope">{{
              scope.row.price.toFixed(2)
            }}</template>
          </el-table-column>
        </el-table>
        <div class="text-info-12 mt-10" v-else>
          {{ keyword.length > 0 ? '未找到对应产品，或产品已被添加' : '' }}
        </div>
      </el-tab-pane>
      <el-tab-pane label="新产品" name="tab2">
        <el-form
          size="small"
          ref="form"
          label-width="100px"
          class="mt-20"
          :model="itemModel"
          :rules="formRules"
        >
          <el-form-item label="零件名称" prop="name">
            <el-input v-model="itemModel.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="件号" prop="part_number">
            <el-input
              v-model="itemModel.part_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="机型" prop="machine_type">
            <el-select
              v-model="itemModel.machine_type"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词搜索"
              :remote-method="searchMachineTypeOptions"
              :loading="loading"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in options"
                :key="item + index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <el-input v-model="model.machine_type" autocomplete="off"></el-input> -->
          </el-form-item>

          <el-form-item label="描述" prop="description">
            <el-input
              v-model="itemModel.description"
              autocomplete="off"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="成本价" prop="price">
            <el-input-number
              v-model="itemModel.cost_price.price"
              :precision="2"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="定价" prop="price">
            <el-input-number
              v-model="itemModel.price"
              :precision="2"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { itemList, createItem, itemCategoryList } from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
    //是否搜索设备
    multiple: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    keyword: 'searchItems',
    search_table: 'searchItems',
  },
  data() {
    return {
      search_table: 'item',
      keyword: '',
      options: [],
      loading: false,
      visible: this.show,
      items: [],
      selectionTmp: [],
      tabActive: 'tab1',
      selectedItems: [],
      lastTimestamp: 0,
      submiting: false,
      itemModel: {
        category: 1,
        name: '',
        part_number: '',
        description: '',
        cost_price: {
          price: 0,
        },
        price: 0,
      },
      formRules: {
        name: [
          { required: true, message: '请输入零件名称', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {},
  methods: {
    async searchItems() {
      let items = []
      this.items = []
      if (this.keyword && this.keyword.length > 0) {
        let res = await itemList({
          page: 0,
          size: 10,
          query: this.keyword,
        })

        if (res.code == 0) {
          items = res.data.list.filter((item) => item.package == 0)
        }
      }

      if (this.selection.length == 0) {
        this.items = items
      } else {
        this.items = items.filter((i) => {
          return !this.selection.some((j) => i.id == j.id)
        })
      }
    },
    handleItemSelectionChange(val) {
      this.selectionTmp = val.map((item) => {
        item.count = 1
        item.checked = true
        item.price = item.price ? item.price : 0
        return item
      })
    },
    submit() {
      if (this.tabActive == 'tab1') {
        this.visible = false
        this.$emit('selected', this.selectionTmp)
      } else {
        this.createNewItem()
      }
    },
    opened() {
      this.keyword = ''
      this.items = []

      this.itemModel = {
        name: '',
        category: 1,
        part_number: '',
        description: '',
        cost_price: {
          price: 0,
        },
        price: 0,
        machine_type: [],
      }
    },
    async searchMachineTypeOptions(query) {
      if (!query) {
        this.options = []
        return
      }
      let res = await itemCategoryList({
        page: 0,
        size: 1000,
        category: 2,
        query: query,
      })
      this.options = res.data.list.map((item) => {
        return item.name
      })
    },
    async createNewItem() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          if (this.itemModel.machine_type) {
            this.itemModel.machine_type = this.itemModel.machine_type.join(',')
          } else {
            this.itemModel.machine_type = ''
          }
          let res = await createItem(this.itemModel)
          this.submiting = false
          if (res.code == 0) {
            let item = res.data
            item.count = 1
            item.checked = true
            this.selectionTmp = [item]
            this.$emit('selected', this.selectionTmp)
            this.visible = false
          }
        } else {
          this.submiting = false
        }
      })
    },
  },
}
</script>